import {Navbar, Container, Nav} from "react-bootstrap";
import { User } from "../models/user";
import NavBarLoggedOutView from "./navbarLoggedOutView";
import NavBarLoggedInView from "./navbarLoggedInView";
import {Link} from "react-router-dom";

interface navbarProps{
    loggedInUser: User | null,
    onSignUpClicked: ()=> void,
    onLogInClicked: ()=> void,
    onLogoutSuccessful: ()=> void,
}

const NavBar=({loggedInUser, onSignUpClicked, onLogInClicked, onLogoutSuccessful}: navbarProps)=>{
    return(
        <Navbar bg="primary" variant="dark" expand="sm" sticky="top">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    Cool Notes App
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar" />
                <Navbar.Collapse id="main-navbar">
                    <Nav>
                        <Nav.Link as={Link} to="/privacy">
                            Privacy
                        </Nav.Link>
                    </Nav>
                    <Nav className="ms-auto">
                        {loggedInUser 
                        ? <NavBarLoggedInView user={loggedInUser} onLogoutSuccessful={onLogoutSuccessful} />
                        : <NavBarLoggedOutView onLoginClicked={onLogInClicked} onSignUpClicked={onSignUpClicked} />
                    }
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default NavBar;
